import { Component, input } from '@angular/core';
import { BeforeAfter } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-setup-wizard-before-after',
	standalone: true,
	imports: [],
	templateUrl: './setup-wizard-before-after.html',
	styleUrl: './setup-wizard-before-after.scss',
})
export class SetupWizardBeforeAfter<T> {
	data = input.required<BeforeAfter<T>>();
	key = input.required<keyof T>();
}
